import { render, staticRenderFns } from "./RosettesDetail.vue?vue&type=template&id=0e9e80e0&scoped=true&"
import script from "./RosettesDetail.vue?vue&type=script&lang=js&"
export * from "./RosettesDetail.vue?vue&type=script&lang=js&"
import style0 from "./RosettesDetail.vue?vue&type=style&index=0&id=0e9e80e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9e80e0",
  null
  
)

export default component.exports